var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVixco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5144 6.47168L20.6586 26.445H13.2734L20.6038 12.9598C21.6376 11.0577 23.1507 9.45885 24.9931 8.32202C26.8354 7.18518 28.943 6.54981 31.1067 6.47895C31.2414 6.47478 31.3788 6.47168 31.5144 6.47168Z",
    fill: "url(#paint0_linear_1192_2501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.56934 6.47168L12.4252 26.445H19.8103L12.4797 12.9598C11.446 11.0576 9.93283 9.45883 8.09044 8.32199C6.24805 7.18515 4.14043 6.54979 1.97669 6.47895C1.84236 6.47478 1.70494 6.47168 1.56934 6.47168Z",
    fill: "url(#paint1_linear_1192_2501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1192_2501",
    x1: 28.7965,
    y1: 4.5143,
    x2: 14.8126,
    y2: 26.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1192_2501",
    x1: 4.28724,
    y1: 4.5143,
    x2: 18.2711,
    y2: 26.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B9EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVixco);
export default __webpack_public_path__ + "static/media/vixco.e33d6004790030a1f554ca2fe5687db9.svg";
export { ForwardRef as ReactComponent };